module.exports = __webpack_public_path__ + "static/media/loader.9c7bcaa1.gif";